import { Fragment } from 'react';
import { Accordion, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { TFAQ } from './types';

export const Faq: React.FC = () => {
  const device = useDeviceType();

  const { config } = useApplicationContext();

  const faq = config.get<TFAQ>('b2b-marketing-vas-promotion-frontend.faq');

  if (faq === null) {
    return null;
  }

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Ответы на вопросы</div>
      <Accordion
        size={device === 'desktop' ? 'L' : 'S'}
        items={faq.map(item => ({
          ...item,
          content: (
            <div className={styles['answer']}>
              {item.content.map((elems, elemsIndex) => (
                <p key={elemsIndex}>
                  {elems.map((fragment, fragmentIndex) => {
                    if (fragment.type === 'link') {
                      return (
                        <Fragment key={fragmentIndex}>
                          <a href={fragment.url} className={styles['link']}>
                            {fragment.value}
                          </a>{' '}
                        </Fragment>
                      );
                    }

                    return <span key={fragmentIndex}>{fragment.value} </span>;
                  })}
                </p>
              ))}
            </div>
          ),
        }))}
      />
    </div>
  );
};
